import { render, staticRenderFns } from "./GeoData.vue?vue&type=template&id=785f697e"
import script from "./GeoData.vue?vue&type=script&lang=js"
export * from "./GeoData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports